package com.example.hukakmp.draft

import com.example.hukakmp.model.EspecieEntry
import com.example.hukakmp.model.ModalidadPesca
import com.example.hukakmp.model.NuevoParteInput
import kotlinx.serialization.Serializable

@Serializable
data class PersistedSpeciesEntry(
    val especie: String = "",
    val cantidad: Int = 0,
    val devueltos: Int = 0,
)

@Serializable
data class PersistedReportDraft(
    val fecha: String = "",
    val horaInicio: String = "",
    val horaFin: String = "",
    val modalidad: String? = null,
    val modalidadOtra: String = "",
    val numeroCanas: Int? = null,
    val nombreLugar: String = "",
    val zona: String = "",
    val latitud: String = "",
    val longitud: String = "",
    val especies: List<PersistedSpeciesEntry> = emptyList(),
    val observaciones: String = "",
)

fun NuevoParteInput.toPersistedDraft(): PersistedReportDraft =
    PersistedReportDraft(
        fecha = fecha,
        horaInicio = horaInicio,
        horaFin = horaFin,
        modalidad = modalidad?.name,
        modalidadOtra = modalidadOtra,
        numeroCanas = numeroCanas,
        nombreLugar = nombreLugar,
        zona = zona,
        latitud = latitud,
        longitud = longitud,
        especies = especies.map {
            PersistedSpeciesEntry(
                especie = it.especie,
                cantidad = it.cantidad,
                devueltos = it.devueltos,
            )
        },
        observaciones = observaciones,
    )

fun PersistedReportDraft.toNuevoParteInput(): NuevoParteInput =
    NuevoParteInput(
        fecha = fecha,
        horaInicio = horaInicio,
        horaFin = horaFin,
        modalidad = modalidad?.let { stored ->
            ModalidadPesca.entries.firstOrNull { it.name == stored }
        },
        modalidadOtra = modalidadOtra,
        numeroCanas = numeroCanas,
        nombreLugar = nombreLugar,
        zona = zona,
        latitud = latitud,
        longitud = longitud,
        especies = especies.map {
            EspecieEntry(
                especie = it.especie,
                cantidad = it.cantidad,
                devueltos = it.devueltos,
            )
        },
        observaciones = observaciones,
    )

expect object ReportDraftPersistence {
    fun load(uid: String): String?
    fun save(uid: String, value: String)
    fun clear(uid: String)
}
